import { NgClass, NgFor, NgIf } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { ExtendedModule } from "@angular/flex-layout/extended";
import { UntypedFormControl } from "@angular/forms";
import { MatList } from "@angular/material/list";
import { MatTooltip } from "@angular/material/tooltip";
import { Router } from "@angular/router";
import { NotificationService } from "src/app/shared/services/notification.service";
import { Notification, UpdateNotification } from "../../../models/notification.model";
import { InitialsPipe } from "../../../routes/pipes/Initials.pipe";
import { BackendService } from "../../../service/backend.service";

@Component({
  selector: "app-notifications",
  templateUrl: "./notifications.component.html",
  styleUrls: [
    "./notifications.component.scss",
    "../../../common/common-search/common-search.component.scss",
  ],
  imports: [NgFor, MatList, NgIf, MatTooltip, NgClass, ExtendedModule, InitialsPipe],
})
export class NotificationsComponent implements OnInit {
  @Input() notifications: Notification[];

  intervals = [
    { label: "year", seconds: 31536000 },
    { label: "month", seconds: 2592000 },
    { label: "week", seconds: 604800 },
    { label: "day", seconds: 86400 },
    { label: "hour", seconds: 3600 },
    { label: "minute", seconds: 60 },
    { label: "second", seconds: 1 },
    { label: "second", seconds: -1 }, // this handles the 0 seconds ago case
  ];
  position = new UntypedFormControl("right");

  constructor(
    public notificationService: NotificationService,
    public backendService: BackendService,
    private router: Router
  ) {}

  ngOnInit(): void {}

  timeSince(dateString): string | null {
    const seconds = Math.floor((new Date().getTime() - new Date(dateString).getTime()) / 1000);
    const interval = this.intervals.find((i) => i.seconds <= seconds);
    // handles future dates
    if (!interval) {
      return "";
    }
    const count = Math.floor(seconds / interval.seconds);
    return `${count} ${interval.label}${count !== 1 ? "s" : ""} ago`;
  }

  formatMessage(notification: Notification): string {
    let message: string;
    switch (notification.actionType) {
      case "Approved":
        message = "Approved your role: ";
        break;
      case "Returned":
        message = "Returned your role: ";
        break;
      default:
        message = "Is waiting for approval on: ";
    }

    return message.concat(
      notification.notificationContext.roleName,
      ", ",
      notification?.roleMastery?.charAt(0).toUpperCase(),
      notification?.roleMastery?.slice(1)
    );
  }

  updateNotification(event: Event, notification: Notification, isUnread: boolean) {
    event.preventDefault();
    const updateNotificationModel: UpdateNotification = {
      isUnread: isUnread ? false : true,
      notificationDate: notification.notificationDate,
    };
    this.notificationService
      .updateNotification(notification.notificationId, updateNotificationModel)
      .subscribe();
    event.stopPropagation();
  }

  getToolTipMessage(isUnread: boolean): string {
    return isUnread ? "Mark as Read" : "Mark as Unread";
  }

  visitNotification(event: Event, notification: Notification): void {
    const url = this.generateNotificationUrl(notification);
    this.router
      .navigateByUrl("/", { skipLocationChange: true })
      .then(() => this.router.navigate([url]));

    this.updateNotification(event, notification, true);
  }

  generateNotificationUrl(notification: Notification): string {
    if (notification.entityType === "role") {
      switch (notification.actionType) {
        case "Approved":
        case "Returned":
          return `/roles/my-roles/${notification.notificationContext.employeeRoleId}`;
        case "Pending":
          return `/team/${notification.relatedEmployee.employeeId}/role/${notification.notificationContext.employeeRoleId}`;
      }
    }
  }
}
